
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ColorERP } from 'src/app/model/ColorERP';






// const httpOptions = {
//   headers: new HttpHeaders({
//     'Content-Type':  'application/json'
//   })
//   };



  @Injectable({
    providedIn: 'root'
  })
  export class ColorERPService {
    private url : string = `${environment.HOST_ERP}`;
    isLoading: boolean = true;
    data: any;

    constructor(
        private http : HttpClient,
        private router : Router
      ) { 


      

      }

      
   getColores(){
   
   }

      
//       getColores():Observable<ColorERP[]{
//       //  const corsAnywhere = 'https://storenew-001-site3.atempurl.com/api';

//       return fetch("https://storenew-001-site3.atempurl.com/api/producto?modelo=3365328&ClaveMarca=A", {
//         referrer: 'http://localhost:4200',
//         referrerPolicy: 'origin',
//        mode: 'no-cors',
//         method: 'GET',
//         body: JSON.stringify(ColorERP)
//       });

      
// }

 getColorERP(_modelo:String,_clave:String):Observable<ColorERP[]>{


  return this.http.get<ColorERP[]>(`${this.url}/producto?modelo=${_modelo}&ClaveMarca=${_clave}`);
    
 }





}